import { Metrics, mobileSize } from "Themes/Metrics";
import styled from "styled-components";


export const MainContainer = styled.div`
  padding-top: 20;
  margin: auto;
  margin-top: 2.5%;
  width: 60%;
  @media ${mobileSize.large} {
    padding: 5px;
    width: 100%;
  }
`;

export const SettingsContentContainer = styled.div`
    flex: 3
    @media ${mobileSize.large} {
      flex: 1;
    }
`
export const SettingsContainer = styled.div`
  display: flex;
  @media ${mobileSize.large} {
    flex-direction: column;
  }
`;

const styles = {
  container: {
    ...Metrics.mainContainer,
  },
  settingsContainer: {
    display: "flex",
  },
  settings: {
    flex: 3
  },
  navigationSidepanel: {
    flex: 1,
  },
};

export default styles;
